import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  selectMusicLoading,
  selectMusicUrl,
  selectMusicError,
  selectMusicProgress,
  selectMusicResult,
  resetMusicState,
  setChatbotId,
  fetchMusic,
  selectMusicTimerActive,
  selectMusicTimerCompleted,
  resetMusicTimer,
  selectUser,
  selectTilesDetails,
  selectRestrictedDataError,
  selectIsLoading,
  fetchData,
  selectOpenAiTokens,
  fetchUserData,
  selectPremiumGranted,
  selectGenerationCounts,
  selectActiveSubscription,
  fetchActiveSubscription,
  startMusicProgressTimer,
  setMusicResult,
  setMusicError,
  updateChatHistoryEntry,
} from '../../../../mainApp/features/DataSlice/dataSlice';
import { auth, db } from "../../firebase";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { onAuthStateChanged } from "firebase/auth";
import { 
  IoRefresh,           // 🔄 Nowy Utwór  
  IoPlay,              // ▶️ Play
  IoPause,             // ⏸️ Pause
  IoDownload,          // ⬇️ Download
  IoClose              // ✕ Close (opcjonalnie)
} from 'react-icons/io5';
// Import wszystkich styled components
import {
  AppContainer,
  DesktopLayout,
  MusicContainer,
  DesktopTitle,
  MusicPlayerArea,
  GenerateButton,
  StatusContainer,
  ProgressContainer,
  ErrorMessage,
  MusicSuccess,
  FormGroup,
  Label,
  Input,
  TextArea,
  Select,
  CheckboxContainer,
  Checkbox,
  HelpText,
  ProgressText,
  LoadingSpinner,
  MusicPlayerContainer,
  MusicPlayerHeader,
  MusicTitle,
  CloseButton,
  AudioControls,
  PlayButton,
  ProgressBarContainer,
  ProgressBar,
  ProgressFill,
  TimeDisplay,
  ModeSection,
  SectionTitle,
  DownloadButtonContainer,
  DownloadButton,
  SuccessCheckmark,
  LabelContainer,
  LabelText,
  DisabledIndicator
} from './styled';
import styled, { useTheme } from 'styled-components';
import { StyledButton } from '../styled';
import { useNavigate } from 'react-router-dom';
import LoadingPage from '../../TechnicalTabs/LoadingPage';
import ErrorPage from '../../../../mainApp/features/TechnicalTabs/ErrorPage';
import { handleUnauthorizedAccess } from '../../Utility/handleUnauthorizedAccess';
import { MUSIC_GENERATION_COST } from "../../Utility/tokenCosts";

const InlineLinkButton = styled.a`
  background: linear-gradient(135deg, #1e90ff, #00bfff);
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  display: inline-block;
  padding: 2px 8px;
  font-size: 13px;
  margin-left: 8px;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 2px 10px rgba(0, 191, 255, 0.3);
  }
`;

const GenerationCounter = styled.span`
  
  color: ${({ remaining }) => (remaining > 0 ? '#1db954' : '#ff4d4d')};

  font-weight: 600;
`;

export { MusicPlayer, MultiMusicPlayer };

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
// Funkcja do programoowego pobierania pliku
const downloadFile = async (url, filename) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = filename || 'music.mp3';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Zwolnij pamięć
    window.URL.revokeObjectURL(downloadUrl);
  } catch (error) {
    console.error('Error downloading file:', error);
    // Fallback - otwórz w nowej karcie
    window.open(url, '_blank');
  }
};

// Komponent Music Player
const MusicPlayer = ({ audioUrl, title, duration, onClose, hideCloseButton = false }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const theme = useTheme();
  const [currentTime, setCurrentTime] = useState(0);
  const [totalDuration, setTotalDuration] = useState(duration || 0);
  const [downloaded, setDownloaded] = useState(false);
  const [showSuccessAnimation, setShowSuccessAnimation] = useState(false);
  const [broken, setBroken] = useState(false);
  const audioRef = React.useRef(null);

  const handlePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      setTotalDuration(audioRef.current.duration);
    }
  };

  const handleSeek = (e) => {
    const progressBar = e.currentTarget;
    const clickX = e.nativeEvent.offsetX;
    const width = progressBar.offsetWidth;
    const newTime = (clickX / width) * totalDuration;
    if (audioRef.current) {
      audioRef.current.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  const handleDownload = async (e) => {
    e.preventDefault();
    const filename = `${title || 'music'}.mp3`;
     setDownloaded(true);
  setShowSuccessAnimation(true);
  const downloadToast = toast.loading("Pobieranie...", {
    position: "top-right",
    autoClose: false, // Nie zamykaj automatycznie
  });
    try {
      await downloadFile(audioUrl, filename);
      
      // Pokaż animację sukcesu i toast
    
    
      toast.update(downloadToast, {
      render: "Pobrano!",
      type: "success",
      isLoading: false,
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
    });
        setTimeout(() => {
      setDownloaded(false);
      setShowSuccessAnimation(false);
    }, 2000); // Oba stany resetują się po 2 sekundach
    
        setDownloaded(false);
   setTimeout(() => {
    setShowSuccessAnimation(false);
  }, 2000);
      
    } catch (error) {
       setDownloaded(false);
    setShowSuccessAnimation(false);
      toast.error(`Nie udało się pobrać pliku: ${error.message}`, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  if (broken) {
    return (
      <MusicPlayerContainer>
        <div style={{ textAlign: "center", color: "#ff4d4d", padding: "20px" }}>
          Muzyka usunięta. Uwaga, materiały audio zawsze usuwane są cyklicznie co 60 dni. Pamiętaj by zapisywać je na dysku.
        </div>
      </MusicPlayerContainer>
    );
  }

  return (
    <MusicPlayerContainer>
      {!hideCloseButton && (
        <MusicPlayerHeader>
          <MusicTitle>{title || 'Generated Music'}</MusicTitle>
          <CloseButton onClick={onClose}>✕</CloseButton>
        </MusicPlayerHeader>
      )}
      
      <AudioControls>
       <PlayButton onClick={handlePlay}>
  {isPlaying ? (
    <IoPause color={theme.color.white} size={24} />
  ) : (
    <IoPlay color={theme.color.white} size={24}  style={{ transform: 'translateX(2px)' }}/>
  )}
</PlayButton>
        <ProgressBarContainer onClick={handleSeek}>
          <ProgressBar>
            <ProgressFill style={{ width: `${totalDuration > 0 ? (currentTime / totalDuration) * 100 : 0}%` }} />
          </ProgressBar>
          <TimeDisplay>
            <span>{formatTime(currentTime)}</span>
            <span>{formatTime(totalDuration)}</span>
          </TimeDisplay>
        </ProgressBarContainer>
        <DownloadButtonContainer>
         <DownloadButton onClick={handleDownload}>
  {downloaded ? (
    "Pobrano!"
  ) : (
    <>
      <IoDownload color="white" size={16} style={{ marginRight: '5px' }} />
      Pobierz
    </>
  )}
</DownloadButton>
          {showSuccessAnimation && (
            <SuccessCheckmark>
              <svg className="loading-circle" viewBox="0 0 24 24">
                <circle cx="12" cy="12" r="10" />
              </svg>
              <div className="checkmark">✓</div>
            </SuccessCheckmark>
          )}
        </DownloadButtonContainer>
      </AudioControls>
      
      <audio
        ref={audioRef}
        src={audioUrl}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={() => setIsPlaying(false)}
        onError={() => setBroken(true)}
      />
    </MusicPlayerContainer>
  );
};

// Komponent dla wielu utworów
const MultiMusicPlayer = ({ musicResult, onClose, hideCloseButton = false }) => {
  const tracks = musicResult.tracks || [musicResult];
  
  return (
    <MusicPlayerContainer>
      <MusicPlayerHeader>
        <MusicTitle>Wygenerowane utwory ({tracks.length})</MusicTitle>
          {!hideCloseButton && (
        <CloseButton onClick={onClose}>
  <IoClose color="white" size={18} />
</CloseButton>)}
      </MusicPlayerHeader>
      
      {tracks.map((track, index) => (
        <div key={index}>
          <h4>Utwór {track.trackNumber || (index + 1)}: {track.title}</h4>
          <MusicPlayer
            audioUrl={track.audioUrl}
            title={track.title}
            duration={track.duration}
            onClose={() => {}}
            hideCloseButton={true}
          />
        </div>
      ))}
    </MusicPlayerContainer>
  );
};

// Główny komponent chatbota
const MusicBot = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoading = useSelector(selectIsLoading);
  const user = useSelector(selectUser);
  const tilesDetails = useSelector(selectTilesDetails);
  const restrictedDataError = useSelector(selectRestrictedDataError);
  const musicLoading = useSelector(selectMusicLoading);
  const musicUrl = useSelector(selectMusicUrl);
  const musicError = useSelector(selectMusicError);
  const musicProgress = useSelector(selectMusicProgress);
  const musicResult = useSelector(selectMusicResult);
  const musicTimerActive = useSelector(selectMusicTimerActive);
  const musicTimerCompleted = useSelector(selectMusicTimerCompleted);
  const openAiTokens = useSelector(selectOpenAiTokens);
  const premiumGranted = useSelector(selectPremiumGranted);
  const generationCounts = useSelector(selectGenerationCounts);
  const activeSubscription = useSelector(selectActiveSubscription);
  
  const validationToastId = 'music-bot-validation-toast';
  const limitToastId = 'music-creator-limit-toast';
  
  const STANDARD_MONTHLY_ID = process.env.REACT_APP_STANDARD_MONTHLY;
  const STANDARD_YEARLY_ID = process.env.REACT_APP_STANDARD_YEARLY;

  const isStandardPlan = activeSubscription && 
    (activeSubscription.priceId === STANDARD_MONTHLY_ID || activeSubscription.priceId === STANDARD_YEARLY_ID);

  const [initialLoading, setInitialLoading] = useState(true);
  const [currentTaskId, setCurrentTaskId] = useState(null);
  const [processedTaskIds, setProcessedTaskIds] = useState(new Set());
  const [messages, setMessages] = useState([]);
  const [generationIsLoading, setGenerationIsLoading] = useState(false);
  const timeoutRef = useRef(null);

  const [formData, setFormData] = useState({
    prompt: '',
    style: '',
    title: '',
    lyrics: '',
    instrumental: false,
    customMode: false,
    model: 'V3_5'
  });

  const [showMusicPlayer, setShowMusicPlayer] = useState(false);

  useEffect(() => {
    dispatch(setChatbotId("music"));
    dispatch(fetchData());
    dispatch(fetchActiveSubscription());
  }, [dispatch]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        try {
          dispatch(fetchData());
          dispatch(fetchUserData());
          dispatch(fetchActiveSubscription());
          const ref = doc(db, "Users", currentUser.uid);
          const snap = await getDoc(ref);
          if (!snap.exists()) {
            console.warn("Dokument użytkownika nie istnieje.");
          }
          await delay(600);
        } catch (error) {
          console.error("Błąd pobierania danych użytkownika:", error);
          await delay(600);
        }
      } else {
        navigate("/login");
      }
      setInitialLoading(false);
    });
    return () => unsubscribe();
  }, [dispatch, navigate]);

  // NOWY LISTENER - jak w VideoCreator
  useEffect(() => {
    if (user && currentTaskId) {
      console.log('🎵 Setting up listener for taskId:', currentTaskId);
      const unsub = onSnapshot(doc(db, `Users/${user.uid}/chatHistory`, currentTaskId), (doc) => {
        if (doc.exists()) {
          const data = doc.data();
          const messageData = { id: doc.id, ...data };

          console.log('🎵 Firestore update received:', messageData);

          setMessages(prevMessages => {
            const existingMessageIndex = prevMessages.findIndex(m => m.id === doc.id);
            if (existingMessageIndex > -1) {
              const updatedMessages = [...prevMessages];
              updatedMessages[existingMessageIndex] = messageData;
              return updatedMessages;
            } else {
              return [...prevMessages, messageData];
            }
          });

          // Start progress timer gdy status zmienia się na processing
          if (data.status === 'processing' && !musicTimerActive && !musicTimerCompleted) {
            console.log('🎵 Starting music progress timer');
            dispatch(startMusicProgressTimer());
          }

          // Obsługa zakończonego generowania
          if ((data.status === 'completed' || data.status === 'error') && !processedTaskIds.has(currentTaskId)) {
            if (timeoutRef.current) {
              clearTimeout(timeoutRef.current);
            }
            setGenerationIsLoading(false);
            
            if (data.status === 'completed') {
              console.log('🎵 Music generation completed!');
              try {
                const musicData = JSON.parse(data.content);
                dispatch(setMusicResult({
                  taskId: currentTaskId,
                  audioUrl: musicData.audioUrl,
                  title: musicData.title,
                  status: 'completed',
                  progress: 100,
                  duration: musicData.duration,
                  tracks: musicData.tracks
                }));
                dispatch(updateChatHistoryEntry(messageData));
                dispatch(fetchUserData()); // Refresh tokens
                setShowMusicPlayer(true);
              } catch (e) {
                console.error('🎵 Error parsing music data:', e);
                dispatch(setMusicError('Błąd przetwarzania danych muzyki'));
              }
            } else if (data.status === 'error') {
              console.error('🎵 Music generation failed:', data.content);
              dispatch(setMusicError(data.content || 'Wystąpił nieznany błąd podczas generowania muzyki.'));
            }
            
            // Zatrzymaj timer
            dispatch(resetMusicTimer());
            setProcessedTaskIds(prev => new Set(prev).add(currentTaskId));
          }
        }
      });
      
      return () => {
        console.log('🎵 Cleaning up listener for taskId:', currentTaskId);
        unsub();
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
      };
    }
  }, [user, currentTaskId, dispatch, processedTaskIds, musicTimerActive, musicTimerCompleted]);


  useEffect(() => {
    if (musicResult && musicResult.status === 'completed' && (musicResult.audioUrl || musicResult.tracks)) {
      setShowMusicPlayer(true);
    }
  }, [musicResult]);

  const musicGenerations = generationCounts?.music || 0;
  const remainingGenerations = 3 - musicGenerations;

  useEffect(() => {
    if (isStandardPlan) {
      const toastOptions = {
        toastId: limitToastId,
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      };

      const message = `Limit generacji w planie Standard: ${remainingGenerations}/3`;

      if (toast.isActive(limitToastId)) {
        toast.update(limitToastId, { render: message });
      } else {
        toast.info(message, toastOptions);
      }
    }
  }, [isStandardPlan, remainingGenerations]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleGenerate = async () => {
    const toastOptions = {
      position: "top-center",
      toastId: validationToastId
    };

    if (!user) {
      toast.error("Nie jesteś zalogowany", toastOptions);
      return;
    }

    if (isStandardPlan && remainingGenerations <= 0) {
      toast.error("Osiągnięto limit generacji muzyki w planie Standard.", toastOptions);
      return;
    }

    if (openAiTokens < MUSIC_GENERATION_COST) {
      toast.error("Masz za mało tokenów, aby wygenerować muzykę.", toastOptions);
      return;
    }

    // Walidacja formularza
    if (formData.customMode) {
      if (formData.instrumental) {
        if (!formData.prompt.trim()) {
          toast.error('W trybie instrumentalnym wypełnij styl muzyki', toastOptions);
          return;
        }
      } else {
        if (!formData.title.trim() || !formData.style.trim()) {
          toast.error('W trybie kreatywnym wypełnij tytuł i styl muzyczny', toastOptions);
          return;
        }
        if (!formData.lyrics.trim()) {
          toast.error('Wypełnij tekst piosenki lub zaznacz "tylko melodia"', toastOptions);
          return;
        }
      }
    } else {
      if (!formData.prompt.trim()) {
        toast.error('Wypełnij styl muzyki', toastOptions);
        return;
      }
    }

    setGenerationIsLoading(true);
    dispatch(setMusicError(null));
    dispatch(resetMusicTimer());
    setShowMusicPlayer(false);

    try {
      const token = await auth.currentUser.getIdToken();
      
      const payload = {
        customMode: formData.customMode,
        instrumental: formData.instrumental,
        model: formData.model
      };

      if (formData.customMode) {
        payload.title = formData.title || 'AI Generated Music';
        payload.style = formData.style || 'default';
        if (formData.instrumental) {
          payload.prompt = formData.prompt;
        } else {
          payload.prompt = formData.lyrics;
        }
      } else {
        payload.prompt = formData.prompt;
      }

      console.log('🎵 Sending music generation request:', payload);

      const response = await fetch('/.netlify/functions/start-music-generation', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Coś poszło nie tak');
      }

      const data = await response.json();
      console.log('🎵 Received taskId:', data.taskId);
      setCurrentTaskId(data.taskId);

      // Timeout jako zabezpieczenie (12 minut dla muzyki)
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        toast.error("Przeciążenie sieci, spróbuj ponownie za kilka minut, przepraszamy!");
        setGenerationIsLoading(false);
        dispatch(resetMusicTimer());
        setProcessedTaskIds(prev => new Set(prev).add(data.taskId));
      }, 12 * 60 * 1000);

      setMessages(prev => [...prev, { 
        id: `user-${Date.now()}`, 
        isUser: true, 
        content: payload.prompt, 
        timestamp: new Date() 
      }]);

    } catch (err) {
      console.error('🎵 Music generation error:', err);
      dispatch(setMusicError(err.message));
      toast.error(err.message);
      setGenerationIsLoading(false);
    }
  };

  const handleReset = () => {
    dispatch(resetMusicState());
    dispatch(resetMusicTimer());
    setShowMusicPlayer(false);
    setCurrentTaskId(null);
    setGenerationIsLoading(false);
    setMessages([]);
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setFormData({
      prompt: '',
      style: '',
      title: '',
      lyrics: '',
      instrumental: false,
      customMode: false,
      model: 'V3_5'
    });
  };

  const handleCloseMusicPlayer = () => {
    setShowMusicPlayer(false);
  };

    useEffect(() => {
    if (restrictedDataError) {
      navigate("/unauthorized");
    }
  }, [restrictedDataError, navigate]);

  if (initialLoading || isLoading === 'loading') {
    return <LoadingPage />;
  }

  let returned;

  switch (isLoading) {
    case "success":
      if (!user) {
        returned = <LoadingPage isHighZIndex={true} />;
      } else if (tilesDetails.length > 0 && user) {
        returned = (
          <AppContainer>
            <DesktopLayout>
              <DesktopTitle>Generator Muzyki AI</DesktopTitle>
              
              <MusicContainer>
              <ModeSection>
                <SectionTitle>Ustawienia generowania</SectionTitle>
                
                <FormGroup>
                  <CheckboxContainer onClick={() => 
                    handleInputChange({target: {name: 'customMode', type: 'checkbox', checked: !formData.customMode}})}>
                    <Checkbox
                      type="checkbox"
                      name="customMode"
                      checked={formData.customMode}
                      onChange={() => {}}
                    />
                    <Label>Tryb kreatywny</Label>
                  </CheckboxContainer>
                  <HelpText>
                    W trybie kreatywnym możesz precyzyjnie kontrolować tytuł, styl i tekst piosenki
                  </HelpText>
                </FormGroup>
      
                <FormGroup>
                  <CheckboxContainer onClick={() => 
                    handleInputChange({target: {name: 'instrumental', type: 'checkbox', checked: !formData.instrumental}})}>
                    <Checkbox
                      type="checkbox"
                      name="instrumental"
                      checked={formData.instrumental}
                      onChange={() => {}}
                    />
                    <Label>Tylko melodia</Label>
                  </CheckboxContainer>
                  <HelpText>
                    Zostanie wygenerowana tylko muzyka instrumentalna bez wokali
                  </HelpText>
                </FormGroup>
                <FormGroup>
                  <Label>Model AI</Label>
                  <Select
                    name="model"
                    value={formData.model}
                    onChange={handleInputChange}
                  >
                    <option value="V3_5">Standard - szybszy</option>
                    <option value="V4">Premium - lepsza jakość</option>
                  </Select>
                  <HelpText>
                    Premium oferuje lepszą jakość dźwięku, ale generowanie trwa dłużej
                  </HelpText>
                </FormGroup>
      
                <SectionTitle>Szczegóły utworu</SectionTitle>
                <FormGroup>
                   <LabelContainer> <LabelText disabled={formData.customMode && !formData.instrumental}>Styl muzyki</LabelText>{(formData.customMode && !formData.instrumental) && (
                   <DisabledIndicator>(nieaktywne)</DisabledIndicator>
                 )}</LabelContainer>
                  <TextArea
                    name="prompt"
                    value={formData.prompt}
                    onChange={handleInputChange}
                    placeholder={formData.instrumental ? "Opisz styl muzyki, np. 'Spokojny jazz z elementami elektronicznymi'" : "Opisz jaką muzykę chcesz wygenerować i o czym ma być tekst"}
                    rows="4"
                    disabled={formData.customMode && !formData.instrumental}
                  />
                  <HelpText>
                    Opisz styl i klimat muzyki instrumentalnej lub temat piosenki
                  </HelpText>
                </FormGroup>
      
                <FormGroup>
                  <LabelContainer>
                    <LabelText disabled={!formData.customMode}>
                      Tytuł piosenki
                    </LabelText>
                    {!formData.customMode && (
                      <DisabledIndicator>(nieaktywne)</DisabledIndicator>
                    )}
                  </LabelContainer>
                  <Input
                    type="text"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    placeholder="Wprowadź tytuł utworu"
                    disabled={!formData.customMode}
                  />
                </FormGroup>
      
                <FormGroup>
                  <LabelContainer>
                   <LabelText disabled={!formData.customMode || formData.instrumental}>Styl muzyczny</LabelText>
                    {(!formData.customMode || formData.instrumental) && (
                      <DisabledIndicator>(nieaktywne)</DisabledIndicator>
                    )}
                  </LabelContainer>
                  <Input
                    type="text"
                    name="style"
                    value={formData.style}
                    onChange={handleInputChange}
                    placeholder="Pop, Rock, Jazz, Electronic, itp."
                    disabled={!formData.customMode || formData.instrumental}
                  />
                  <HelpText>
                    Możesz łączyć style: "Chill Jazz with Electronic beats" lub "Acoustic Rock Ballad"
                  </HelpText>
                </FormGroup>
      
                <FormGroup>
                  <LabelContainer>
                  <LabelText disabled={!formData.customMode || formData.instrumental}>
                    Tekst piosenki
                  </LabelText>
                  {(!formData.customMode || formData.instrumental) && (
                    <DisabledIndicator>(nieaktywne)</DisabledIndicator>
                  )}
                  </LabelContainer>
                  <TextArea
                    name="lyrics"
                    value={formData.lyrics}
                    onChange={handleInputChange}
                    placeholder="Wprowadź pełny tekst piosenki..."
                    rows="8"
                    disabled={!formData.customMode || formData.instrumental}
                  />
                  <HelpText>
                    Wpisz kompletny tekst piosenki - użyj dowolnego języka
                  </HelpText>
                </FormGroup>
      
              </ModeSection>
      
                <GenerateButton onClick={handleGenerate} disabled={generationIsLoading} tokenCost={MUSIC_GENERATION_COST}>
                  <span className="button-text">
                    {generationIsLoading ? 'Generowanie...' : '🎵 Wygeneruj Muzykę'}
                  </span>
                </GenerateButton>
      
                {!premiumGranted && generationCounts && (
                  <HelpText style={{ textAlign: 'center', marginTop: '1rem' }}>
                    <GenerationCounter remaining={remainingGenerations}>{remainingGenerations}/3</GenerationCounter> dostępnych generacji muzyki.
                  </HelpText>
                )}

                {(showMusicPlayer || musicError) && (
                  <GenerateButton onClick={handleReset} style={{ marginTop: '10px' }}>
                    <span className="button-text">
                      <IoRefresh color="#1db954" size={20} style={{ marginRight: '8px' }} />
                      Nowy Utwór
                    </span>
                  </GenerateButton>
                )}
      
                  <StatusContainer>
                  {musicError && (
                    <ErrorMessage>
                      ❌ {musicError}
                    </ErrorMessage>
                  )}
      
                  {generationIsLoading && (
                    <ProgressContainer>
                      <ProgressText>
                        {typeof musicProgress === 'number' ? (
                          <>
                            {musicProgress}%
                            {musicTimerCompleted && !musicResult && (
                              <span style={{ color: '#ffeb3b', marginLeft: '10px', fontSize: '14px' }}>
                                (chyba potrzebuję jeszcze kilka minut)
                              </span>
                            )}
                          </>
                        ) : (
                          "Przygotowywanie generowania..."
                        )}
                      </ProgressText>
                      
                      <LoadingSpinner />
                      
                      <div style={{ marginTop: '10px', fontSize: '14px', opacity: 0.8 }}>
                        <span style={{  fontSize: '14px',  color: "#cd5c5c" }}>UWAGA!</span> Nie odświeżaj strony aż do zakończenia generowania.<div style={{ marginTop: '10px', fontSize: '14px', opacity: 0.8 }}> ☕ Zrelaksuj się: skomplikowane utwory mogą potrzebować do 10 minut.</div><div style={{ marginTop: '10px', fontSize: '14px', opacity: 0.8 }}>W trakcie możesz korzystać z innych aplikacji.<InlineLinkButton href="/home" target="_blank" rel="noopener noreferrer">Otwórz</InlineLinkButton></div>
                      </div>
      
                    </ProgressContainer>
                  )}
      
                  {showMusicPlayer && musicResult && (
                    <MusicSuccess>
                      🎉 Muzyka gotowa!
                    </MusicSuccess>
                  )}
                </StatusContainer>
              </MusicContainer>
      
              <MusicPlayerArea hasMusic={showMusicPlayer && musicResult}>
                {showMusicPlayer && musicResult ? (
                  <>
                    {musicResult.tracks && musicResult.tracks.length > 1 ? (
                      <MultiMusicPlayer 
                        musicResult={musicResult} 
                        onClose={handleCloseMusicPlayer}
                      />
                    ) : (
                      <MusicPlayer
                        audioUrl={musicResult.audioUrl || musicUrl}
                        title={musicResult.title || 'Generated Music'}
                        duration={musicResult.duration || 0}
                        onClose={handleCloseMusicPlayer}
                      />
                    )}
                  </>
                ) : (
                  <>
                    <div style={{ fontSize: '48px', marginBottom: '20px', opacity: '0.3' }}>🎵</div>
                    <div>Tutaj pojawi się Twoja muzyka</div>
                    <div style={{ fontSize: '14px', marginTop: '10px', opacity: '0.4' }}>
                      Wygeneruj utwór, aby go tutaj posłuchać
                    </div>
                  </>
                )}
              </MusicPlayerArea>
            </DesktopLayout>
            {/* Global overlay to block music bot usage */}
            {/* <div
              style={{
                position: 'fixed',
                inset: 0,
                background: 'rgba(0, 0, 0, 0.5)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#ffffff',
                zIndex: 2147483647,
                textAlign: 'center',
                padding: '24px'
              }}
            >
              <div style={{ maxWidth: 760 }}>
                <div
                  style={{
                    background: 'rgba(0,0,0,0.7)',
                    borderRadius: '12px',
                    padding: '24px 28px',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.4)'
                  }}
                >
                  <div style={{ fontSize: '22px', lineHeight: 1.5 }}>
                    <div>Szykuj się na swoją własną muzyczną karierę!</div>
                    <div style={{ marginTop: '8px' }}>Twój muzyczny kompozytor dostępny już od 20 października!</div>
                  </div>
                  <div style={{ marginTop: '16px', display: 'flex', justifyContent: 'center' }}>
                    <StyledButton onClick={() => window.location.assign('/home')}>Powrót</StyledButton>
                  </div>
                </div>
              </div>
            </div> */}
          </AppContainer>
        );
      } else {
        returned = handleUnauthorizedAccess();
      }
      break;
    case "error":
      returned = <ErrorPage />;
      break;
    default:
      returned = <LoadingPage />;
  }

  return returned;
};

export default MusicBot;